// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__2URxL","isDisabled":"Switch_isDisabled___N_a5","label":"Switch_label__3giNU","switch":"Switch_switch__14y1m","slider":"Switch_slider__1YB_Q"};